import React from 'react';
export function Problem() {
  return <section className="py-[60px] px-5 bg-light" data-id="element-151">
      <div className="max-w-[760px] mx-auto" data-id="element-152">
        <h2 className="text-[22px] md:text-[34px] font-black text-center mb-3 text-text-heading" data-id="element-153">
          ¿Cuántas semanas más vas a{' '}
          <span className="text-gold" data-id="element-154">quedarte callado</span> teniendo algo
          importante para decir?
        </h2>
        <p className="text-center text-text-muted text-[15px] mb-9 leading-relaxed" data-id="element-155">
          Tenés fe. Tenés historia. Tenés algo que podría cambiarle la vida a
          alguien.
          <br data-id="element-156" />
          Pero cada vez que abrís Instagram sentís que no sabés cómo decirlo sin
          sonar forzado, sin perder seguidores o sin que te ignoren.
          <br data-id="element-157" />
          <strong className="text-white" data-id="element-158">
            No es falta de fe. Es falta de un sistema.
          </strong>
        </p>

        <ul className="my-6 space-y-0" data-id="element-159">
          {['Publicás versículos y nadie los comenta ni los guarda', 'Tenés miedo de que te dejen de seguir si hablás de Dios', 'No sabés cómo conectar con personas que no creen', 'Tu cuenta existe, pero no tiene dirección ni propósito claro', 'Cada semana improvisás qué publicar y terminás no publicando nada', 'Sentís que tu fe y tu Instagram son dos mundos separados'].map((pain, i) => <li key={i} className="py-3 border-b border-divider text-[15px] text-text-secondary leading-relaxed flex items-start gap-2" data-id="element-160">
              <span data-id="element-161">❌</span> <span data-id="element-162">{pain}</span>
            </li>)}
        </ul>

        <p className="text-center text-lg font-extrabold text-gold mt-7" data-id="element-163">
          ¿Y si esta fuera la última semana que te quedás sin saber cómo
          hacerlo?
        </p>
      </div>
    </section>;
}